import { render, staticRenderFns } from "./QRMenu.vue?vue&type=template&id=6b07a8bc&scoped=true"
import script from "./QRMenu.vue?vue&type=script&lang=js"
export * from "./QRMenu.vue?vue&type=script&lang=js"
import style0 from "./QRMenu.vue?vue&type=style&index=0&id=6b07a8bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07a8bc",
  null
  
)

export default component.exports